export default "__VITE_ASSET__BSw2e9Hs__"